import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {GetLimits_limits as Limits} from 'nutshell-graphql-types';

import {getPlanPill} from './helpers';
import {PlanCard} from './plan-card';

interface Props {
    limits: Limits | null;
    isHighestPlan: boolean;
}

export function OutOfCreditsNonAdminContent(props: Props) {
    const description = props.isHighestPlan
        ? 'Contact an admin if you need more outcomes or wait for outcomes to reset on the 1st of next month.'
        : 'Contact an admin to upgrade the plan or wait for outcomes to reset on the 1st of next month.';

    return (
        <Stack spacing={16}>
            <Body size='xlarge' isBold={true} color='dark'>
                AI outcomes have been used for the month
            </Body>
            <Body color='dark'>{description}</Body>
            <PlanCard
                planPill={getPlanPill(props.limits?.currentPlanName ?? '')}
                label='Current plan'
                usageText='Your team’s monthly AI outcomes'
                usageCurrent={props.limits?.currentUsage ?? 0}
                usageLimit={props.limits?.currentPlanLimit ?? 0}
                footerText='0 outcomes remaining'
            />
        </Stack>
    );
}
